import HorizontalCard from './horizontal-card';
export default HorizontalCard;
